import React, { useEffect, useState } from 'react'

import { Form, Input, Button, Row, Col, Modal, notification, Select, Option } from "antd";
import { createUser } from '../../../api/user.service';

export default function AddUserFormModal({ fetchAllUsers, isModalOpen, setIsModalOpen, handleOk, handleCancel }) {

    const [options, setOptions] = useState([
        {
            value: 'PK',
            label: 'Pakistan (PK)'
        },
        {
            value: 'US',
            label: 'UNITED STATES (US)'
        },
    ]);
    const [optionsRole, setOptionsRole] = useState([
        {
            value: 2,
            label: 'Manager'
        },
        {
            value: 3,
            label: 'Agent'
        },
        {
            value: 4,
            label: 'Driver'
        },
    ]);

    const onFinish = async (values) => {
        try {
            await createUser(values);
            notification.success({ message: "User added" });
            fetchAllUsers();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: error.response.data.message || error.msg });
            console.error("Error:", error);
        }
    };

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add User" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{ role: 1 }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[{ required: true, message: "Please enter your name" }]}
                            >
                                <Input placeholder="Enter name" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}
                            >
                                <Input placeholder="Enter email" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                label="Mobile"
                                name="mobile"
                                rules={[
                                    { required: true, message: "Please enter your mobile number" },
                                    {
                                        pattern: /^\+[1-9]\d{1,14}$/,
                                        message: "Please enter a valid mobile number with country code (e.g. +923001234567)"
                                    }
                                ]}
                            >
                                <Input placeholder="Enter mobile number with country code (e.g. +923001234567)" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: "Please enter your password" }]}
                            >
                                <Input.Password placeholder="Enter password" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Confirm Password"
                                name="confirm_password"
                                dependencies={["password"]}
                                rules={[
                                    { required: true, message: "Please confirm your password" },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue("password") === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error("Passwords do not match!"));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password placeholder="Confirm password" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Role"
                                name="role"
                                rules={[{ required: true, message: "Please select a role" }]}
                            >
                                <Select
                                    className='vt-sel'
                                    placeholder="Select role"
                                    style={{ height: '37px !important', borderRadius: '8px !important' }}
                                    options={optionsRole}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};